'use strict';
 
module.exports = {
    redisCache: {
        enabled: true
    },
    piwikEnabled: false,
    pollsEnabled: true
};
